<template>
    <button
        class="w-full h-full rounded pt-4 pr-4 pb-4 pl-12 break-all text-left flex items-start transition border border-light-300 hover:border-green-400 box-shadow--hover relative"
        @click="$downloadFile(url, name)"
    >
        <download-icon class="absolute top-4 left-4" />
        <span class="font-FibraOne-UltraBold"> {{ name }} </span>
    </button>
</template>

<script>
export default {
    name: 'DownloadCard',
    props: {
        url: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.box-shadow--hover {
    &:hover {
        box-shadow: 0 4px 15px rgb(28 130 150 / 10%);
    }
}
</style>
